export default __webpack_public_path__ + "static/media/pepsi_.da32f714.svg";